"use client";

import { useMemo } from "react";

type Props = {
  title: string;
  slug: string;
  url?: string;
};

export function ShareButtons({ title, slug, url: absoluteUrl }: Props) {
  const url = useMemo(() => absoluteUrl ?? `https://singingattitude.uk/blog/${slug}`, [absoluteUrl, slug]);
  const shareText = encodeURIComponent(`${title} — Singing Attitude`);
  const whatsappText = encodeURIComponent(url);

  const buttons = [
    { label: "LinkedIn", href: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${shareText}` },
    { label: "WhatsApp", href: `https://wa.me/?text=${whatsappText}` },
    { label: "Instagram DM", href: `https://www.instagram.com/direct/new/?text=${shareText}%20${encodeURIComponent(url)}` },
  ];

  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      {buttons.map((button) => (
        <a
          key={button.label}
          href={button.href}
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-border px-4 py-1.5 text-offwhite/70 transition hover:border-emerald hover:text-emerald"
        >
          {button.label}
        </a>
      ))}
    </div>
  );
}
